import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import PricingFAQSection from 'components/Pricing/PricingFAQ/PricingFAQSection';

import styles from './PricingFAQ.module.scss';

export default class PricingCreativeFAQ extends Component {
  static propTypes = {
    className: PropTypes.string,
    gradient: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['left', 'right']),
    ]),
  };

  static defaultProps = {
    gradient: false,
  };

  constructor() {
    super();

    this.state = {
      visible: false,
    };
  }

  render() {
    const { className, gradient, ...rest } = this.props;

    const { visible } = this.state;

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div
          className={
            (gradient
              ? styles.gradient +
                ' ' +
                (gradient === 'left'
                  ? styles.gradientLeft
                  : styles.gradientRight)
              : styles.noGradient) + (className ? ' ' + className : '')
          }
          {...rest}
        >
          <div className={styles.container}>
            <Grid>
              <Row>
                <h3
                  className={styles.header + (visible ? '' : ' ' + styles.hide)}
                >
                  Frequently asked questions
                </h3>
              </Row>
              <PricingFAQSection
                leftTitle="Can I cancel a Pro subscription?"
                leftText={
                  <span>
                    Yes, of course. You can cancel at any time on the monthly or
                    annual subscription from your{' '}
                    <a target="_blank" href="https://www.twine.net/settings">
                      account settings
                    </a>
                    . Your Pro account will stay active until the billing cycle
                    you paid for finishes.
                  </span>
                }
                rightTitle="What payment methods do you accept?"
                rightText="We accept major credit, debit cards and PayPal. We use Stripe, one of the largest payment platforms in the world, to process our payments."
              />
              <PricingFAQSection
                leftTitle="Do I have to pay anything upfront?"
                leftText={
                  <span>
                    Every job can receive a limited number of applications from
                    free accounts (
                    <a
                      target="_blank"
                      href="https://help.twine.net/en/article/why-cant-i-apply-to-a-job-on-twine-13aguem/"
                    >
                      read more
                    </a>
                    ), so you can try Twine for free. Once the application limit
                    has been reached on a job, you will need to upgrade to Twine
                    Pro to apply on that job.
                    <br />
                    <br />
                    See about{' '}
                    <a
                      target="_blank"
                      href="https://www.twine.net/blog/twine-pro-subscription-for-freelancers/"
                    >
                      how Twine Pro can be cheaper
                    </a>{' '}
                    than commission based marketplaces.
                  </span>
                }
                rightTitle="What if I'm not hired on any jobs?"
                rightText={
                  <span>
                    We cannot guarantee you will be hired with a Twine Pro
                    subscription, but we can provide you job leads (
                    <a target="_blank" href="http://www.twine.net/jobs">
                      see what's currently available on the job board
                    </a>
                    ). Also you can cancel Twine Pro at any time.
                    <br />
                    <br />
                    Twine Pro also offers several other advantages such as the
                    One-page website, AI cover letter writer and promotion on
                    Instagram.
                  </span>
                }
              />
              <PricingFAQSection
                leftTitle="How will I be billed for Pro?"
                leftText={
                  <span>
                    For a monthly plan, we charge on a monthly basis after your
                    purchase. For an annual plan, we will charge on an annual
                    basis after your purchase. <br />
                    You can cancel your subscription any time. For more
                    information please read our{' '}
                    <a target="_blank" href="/terms">
                      terms
                    </a>
                    .
                  </span>
                }
                rightTitle="Can I get a refund on my pro subscription?"
                rightText={
                  <span>
                    Refunds are granted if you have not used your subscription
                    and requested a refunded within 7 days for a monthly plan or
                    14 days for an annual plan. Please see our{' '}
                    <a href="https://help.twine.net/en/article/twine-pro-refund-policy-2cj264/">
                      refund policy
                    </a>{' '}
                    for more information and to submit a request.
                  </span>
                }
              />
            </Grid>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
